import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';

function CaregiverContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/caregiver/manage-profile/:id"
        pathPermissionId={UserPermissionsIds.ReadCaregiver}
        render={(props) => ViewMounter(props, [{
          viewPath: 'caregiver/your_caregiver_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: { id: props.id }
        },
        {
          viewPath: 'caregiver/caregiver_management/caregiver_management',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/cards/patient_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/certdocs"
        pathPermissionId={UserPermissionsIds.AccessPatientCertificationDocumentationStatus}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'physician/patient_management/patient_cert_docs_screen',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/caregiver/profile"
        pathPermissionId={UserPermissionsIds.ManageCaregiverProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'caregiver/your_caregiver_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'caregiver/caregiver_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/caregiver/qualifying-documentation/dashboard/refresh"
        pathPermissionId={UserPermissionsIds.AccessQualifyingDoc}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/qualifying_doc_screen',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/caregiver/qualifying-documentation/crce/:encryptedId"
        pathPermissionId={UserPermissionsIds.ReadQualifyingDoc}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/close_relative/close_relative_caregiver_exception',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/cards"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/cards/patient_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/orders"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/list/orders_list',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/cards/:isNew"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/cards/patient_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/orders"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/list/orders_list',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/cards/calculations/:tab"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/patient/profile/:id/calculations/:tab"
        pathPermissionId={UserPermissionsIds.RepresentedPatientInfo}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:currentUserRole/:appType/applications/:patientId"
        pathPermissionId={UserPermissionsIds.UpdateRepresentedPatientCard}
        render={(props) => ViewMounter(props, [{
          viewPath: 'applications/my_applications',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: undefined,
          viewProps: { caregiverViewingPatient: true },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        }
        ])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:appType/update-demographics/:id"
        pathPermissionId={undefined}
        allowAnonymous
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/form/update_demographics_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
    </div>
  );
}

export default CaregiverContainerScreen;
